import { formatDate } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatSlideToggleChange } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CarService } from 'src/app/services/car/car.service';
import { EntityService } from 'src/app/services/entity/entity.service';
import { HeadquarterService } from 'src/app/services/headquarter/headquarter.service';
import { UserService } from 'src/app/services/user/user.service';
import { VisitService } from 'src/app/services/visit/visit.service';
import { MessageModalComponent } from 'src/app/shared/components/modals/message/message-modal.component';
import { AddVisitNewCarModalComponent } from 'src/app/shared/components/modals/visit/add-visit-new-car-modal/add-visit-new-car-modal.component';
import { AddVisitNewUserModalComponent } from 'src/app/shared/components/modals/visit/add-visit-new-user-modal/add-visit-new-user-modal.component';
import { AddVisitRejectModalComponent } from 'src/app/shared/components/modals/visit/add-visit-reject-modal/add-visit-reject-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-visit-form',
  templateUrl: './visit-form.component.html',
  styleUrls: ['./visit-form.component.css']
})
export class VisitFormComponent implements OnInit {
  visitForm: FormGroup;
  color: string;
  colorFont: string;
  gatewaySelect: number;
  headquarterSelect: number;
  enterpriseSelect: number;
  enabledRead: number;
  enabledWrite: number;
  edit = false;
  public id = 0;
  editHeadquarter = false;
  gateways = [];
  entities = [];
  headquarters = [];
  disabledHeadquarter = false;
  actuatorTypes = [];
  actuatorDataTypes = [];
  actuatorTypeSelect = 0;
  showEntity = false;
  actuatorDataTypeSelect = 0;
  visitTypeSelect = 0;
  validationTypeSelect = 0;
  public new = false;
  selectedCalendar: Date;
  minDate: Date;
  maxDate: Date;
  formattedDate: string;
  isoFormattedDate: string;
  entitySelect = 0;
  state = 0;
  requested = "";
  scheduled = "";
  report = "";
  rejectComment = "";
  timeSelect: number;
  startTime:string;
  endTime:string;
  times = [];
  cars = [];
  types = [
    {id:1,name:'Programada'},
    {id:2,name:'Excepcional'}
  ]
  validationTypes = [
    {id:1,name:'OCR'},
    {id:2,name:'OCR + APP'},
    {id:3,name:'OCR + Local'}
  ];
  users = [];
  onlyCar = false;
  userTypeCreatedBy: number;
  createdBy: number;
  sessionUserId: number;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private entityService: EntityService,
    public dialog: MatDialog,
    private headquarterService: HeadquarterService,
    private carService: CarService,
    private spinner: NgxSpinnerService,
    public activatedRoute: ActivatedRoute,
    private visitService: VisitService,
    private userService: UserService,
    private router: Router,
  ) {
    var _this = this;
    this.sessionUserId = +localStorage.getItem(AppConstants.Session.USERID);
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        if(params.new == "true" || params.new == undefined || params.new == null){
          _this.new = true;
          _this.visitTypeSelect = 1;
          _this.validationTypeSelect = 1;
          _this.state = 1;
          document.getElementById("titleHeaderNav").innerHTML = 'Administración > <span class="font-weight-bold">Nueva Visita</span>';
        }else{
          _this.id = params.id;
          _this.new = false;
          _this.requested = params.requested;
          _this.scheduled = params.scheduled;
          _this.report = params.report;
          if(params.requested == "true" || params.scheduled == "true" || params.report == "true"){
            document.getElementById("titleHeaderNav").innerHTML = 'Administración > <span class="font-weight-bold">Ver Visita</span>';
          }else{
            document.getElementById("titleHeaderNav").innerHTML = 'Administración > <span class="font-weight-bold">Editar Visita</span>';
          }
        }
      });
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.color = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
  }


  ngOnInit() {
    this.createForm();
    this.clearForm();
    this.getEntities();
    //this.getUserVisits();
    //this.getListCarsByEntity();
    if(!this.new){
      this.edit = true;
      this.spinner.show();
      this.visitService.get(this.id).subscribe((response) => {
        if(response.error == null){
          this.visitForm.controls['idEntity'].setValue(response.data.idEntity);
          this.entitySelect = response.data.idEntity;
          this.visitTypeSelect = +response.data.type;
          this.validationTypeSelect = +response.data.idValidationType;
          this.users = response.data.users;
          this.cars = response.data.cars;
          this.timeSelect = response.data.idTime;
          this.selectedCalendar = response.data.date;
          this.startTime = response.data.startTime;
          this.endTime = response.data.endTime;
          this.state = response.data.idState;
          this.userTypeCreatedBy = response.data.userTypeCreatedBy;
          this.createdBy = response.data.createdBy;
          //this.selectedCalendar = response.data.date;
          /*this.visitForm.controls['startTime'].setValue(response.data.startTime);
          this.visitForm.controls['endTime'].setValue(response.data.endTime);*/
          this.rejectComment = response.data.rejectionComment;
          this.visitForm.controls['comment'].setValue(response.data.comment);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.headquarters = [];
        this.spinner.hide();
      });
    }
  }

  clearForm(){
    this.cars = [];
    this.users = [];
    this.visitForm.controls['comment'].setValue("");
    this.selectedCalendar = new Date();
    this.startTime = "";
    this.endTime = "";
    this.entitySelect = 0;
    this.visitTypeSelect= 1;
  }

  changeSelectTime(id){
    this.timeSelect = id;
  }

  addCar(){
    let dialogRef = this.dialog.open(AddVisitNewCarModalComponent, {
      data: {
        color: this.color,
        colorFont: this.colorFont,
        idEntity: this.entitySelect,
        idVisit: this.new ? 0: this.id
      }
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response.car != null) {
        //exist
        console.log("this.cars",this.cars);
        console.log("car",response.car);
        if((this.cars.filter(x => x.licensePlate == response.car.licensePlate)).length == 0){
          this.cars = this.cars.concat(response.car);
          this.onlyCar = true;
        }else{
          this.alertService.showMessage(
            "Ya existe el vehículo en la lista",
            "",
            MessageSeverity.error);
            this.spinner.hide();
        }

      }
    });
  }

  addUser(){

    if(this.cars.length == 0){
      this.alertService.showMessage(
        "No hay vehículos seleccionados",
        "",
        MessageSeverity.error);
        return false;
    }

    let dialogRef = this.dialog.open(AddVisitNewUserModalComponent, {
      data: {
        color: this.color,
        colorFont: this.colorFont,
        cars: this.cars,
        idEntity:this.entitySelect,
        idVisit: this.new ? 0: this.id
      }
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response.user != null) {
        if(this.users != null){
          if((this.users.filter(x => x.idUser == response.user.idUser)).length == 0){
            this.users = this.users.concat(response.user);
          }else{
            this.alertService.showMessage(
              "Ya existe esa persona en la lista",
              "",
              MessageSeverity.error);
          }
        }else{
          this.users.push(response.user);
        }
      }
    });
  }



  getActuatorTypes(){
       /* this.spinner.show();
        this.actuatorService.getListActuatorTypes().subscribe((response) => {
          this.actuatorTypes = response.data;
          this.spinner.hide();
        },
          (error: HttpErrorResponse) => {
            this.spinner.hide();
          });*/
  }

  getEntities(){
    //this.spinner.show();
    this.entityService.getListAll(this.enterpriseSelect).subscribe((response) => {
      this.entities = response.data;
      //this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        //this.spinner.hide();
      });
  }

  getUserVisits(){
    this.spinner.show();
    this.userService.getUserVisits(this.enterpriseSelect).subscribe((response) => {
      this.users = response.data;
      //this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        //this.spinner.hide();
      });
  }
/*
  setHeadquarter(){
    if(this.data.idHeadquarter > 0){
      var headquarters = JSON.parse(localStorage.getItem(AppConstants.Session.HEADQUARTERS));
      var _this = this;
      var items = headquarters.filter(x => x.idEnterprise == _this.data.idEnterprise);
      if(items.length > 0){
        _this.headquarters = items;
        if(_this.data.idHeadquarter != 0){
          _this.headquarterSelect = items[0].id;
          _this.disabledHeadquarter = true;
        }
      }
    }else{
      this.getHeadquarters();
    }
  }
*/

  getHeadquarters() {
    this.spinner.show();
    this.headquarterService.getListAll().subscribe((response) => {
      if(response.error == null){
        //this.headquarters = response.data.filter(f => f.idEnterprise == this.data.idEnterprise);
      }else{
        this.headquarters = [];
      }
    },
      (error: HttpErrorResponse) => {
        this.headquarters = [];
        this.spinner.hide();
      });
}

  createForm(){
    this.visitForm = this.formBuilder.group({
      idVisitType: [1, [Validators.required]],
      idValidationType: [1, [Validators.required]],
      idEntity: [0, []],
      comment: ['', []],
    })
  }

  get f() { return this.visitForm.controls; }

  save(){
    if(
      (this.isoFormattedDate == undefined || this.timeSelect == undefined)
      && this.new){
      this.alertService.showMessage(
        "Debe seleccionar una fecha y un horario",
        "",
        MessageSeverity.error);
      return false;
    }

    if(this.cars.length == 0){
      this.alertService.showMessage(
        "No ha seleccionado ningun vehículo",
        "",
        MessageSeverity.error);
      return false;
    }



    if(this.visitForm.valid){
      const payload = {
        date:this.isoFormattedDate,
        idTime: this.timeSelect,
        idValidationType: this.validationTypeSelect,
        //startTime:this.visitForm.value["startTime"],
        //endTime:this.visitForm.value["endTime"],
        comment: this.visitForm.value["comment"],
        Id: this.new ? 0 : +this.id,
        idEnterprise: this.enterpriseSelect,
        idVisitType: this.visitTypeSelect,
        idEntity: this.entitySelect,
        idOrigin: 1,
        cars: this.cars,
        users: this.users,
        idUser: +localStorage.getItem(AppConstants.Session.USERID)
      }
     this.spinner.show();
     if(this.new){
        this.visitService.create(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.CREATE_VISIT, AppConstants.MessageModal.CREATE, MessageSeverity.success);
            this.spinner.hide();
            this.router.navigate(['home/visit/my-visits']);
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
              this.spinner.hide();
          }
        });
      }else{
        this.visitService.update(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.UPDATE_VISIT, AppConstants.MessageModal.UPDATE, MessageSeverity.success);
            this.spinner.hide();
            this.router.navigate(['home/visit/my-visits']);
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
            this.spinner.hide();
          }
        });
      }
    }else{
      this.visitForm.markAllAsTouched();
    }
  }

  close() {
    this.dialog.closeAll();
  }

  changeGateway(data) {
    this.gatewaySelect = data.value;
  }

  changeValidationType(data) {
    this.validationTypeSelect = data.value;
    /*if(this.validationTypeSelect != 1){
      this.getUserVisits();
    }*/
  }

  changeVisitType(data) {
    this.visitTypeSelect = data.value;
  }

  changeEntity(data) {
    this.entitySelect = data.value;
    this.cars = [];
    this.onlyCar = false;
    //this.getListCarsByEntity();
  }

  deleteCar(data){
    if(this.new){
      this.cars = this.cars.filter(x => x.id != data.id);
      if(this.cars.length == 0){ this.onlyCar = false; }
      if(this.users){
        var countUsers = this.users.filter(x => x.idCar == data.idCar);
        if(countUsers.length > 0){
          countUsers.forEach(y => function(){
            this.deleteUser(y);
          });
        }
      }
    }else{
      this.visitService.deleteVisitCar(this.id,data.id).subscribe(_ => {
        if(_.error == null){
          this.cars = this.cars.filter(x => x.idCar != data.idCar);
          if(this.cars.length == 0){ this.onlyCar = false; }
          if(this.users){
            var countUsers = this.users.filter(x => x.idCar == data.idCar);
            if(countUsers.length > 0){
              countUsers.forEach(y => function(){
                this.deleteUser(y);
              });
            }
          }
        }
      });
    }
  }

  deleteUser(data){
    if(this.new){
      this.users = this.users.filter(x => x.idUser != data.idUser);
    }else{
      console.log("data",data);
      this.visitService.deleteVisitUser(this.id,data.id).subscribe(_ => {
        if(_.error == null){
          this.users = this.users.filter(x => x.idUser != data.idUser);
        }
      });
    }
  }

  changeHeadquarter(data) {
    this.headquarterSelect = data.value;
    //this.gateways = this.data.gateways.filter(x => x.idHeadquarter == data.value);
    if(this.gateways.length>0){
      this.gatewaySelect = this.gateways[0].id;
    }
  }

  changeActuatorDataType(data) {
    this.actuatorDataTypeSelect = data.value;
  }

  changeActuatorType(data) {
    this.actuatorTypeSelect = data.value;
    if(this.actuatorTypeSelect == 3){
      this.actuatorDataTypeSelect = 0;
    }
  }

  changeCarType(event: MatSlideToggleChange){
    this.showEntity = event.checked;
  }

  cancel(){
    if(this.requested == "true"){
      this.router.navigate(['home/visit/requested']);
    }else if(this.scheduled == "true"){
      this.router.navigate(['home/visit/scheduled']);
    }else if(this.report == "true"){
      this.router.navigate(['home/visit/report']);
    }else{
      this.router.navigate(['home/visit/my-visits']);
    }
  }

  onDateChange(event: Date) {
    this.selectedCalendar = event;
    this.updateFormattedDates();
    this.timeSelect = undefined;
  }

  updateFormattedDates() {
    this.formattedDate = formatDate(this.selectedCalendar, 'dd/MM/yyyy', 'en-US');
    this.isoFormattedDate = formatDate(this.selectedCalendar, 'yyyy-MM-dd', 'en-US');
    this.showTimeAvailables();
  }

  getListCarsByEntity(){
    //this.spinner.show();
    this.carService.getListEntity(this.entitySelect).subscribe((response) => {
      if(response.error == null){
        this.cars = response.data;
      }else{
        this.cars = [];
      }
      //this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.headquarters = [];
        //this.spinner.hide();
      });
  }

  showTimeAvailables(){
    //this.spinner.show();
    var payload ={
      IdEnterprise: this.enterpriseSelect,
      Date: this.isoFormattedDate
    }
    this.visitService.GetAvailablesTimeByDate(payload).subscribe((response) => {
      if(response.error == null){
        this.times = response.data;//this.headquarters = response.data.filter(f => f.idEnterprise == this.data.idEnterprise);
      }
      //this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.headquarters = [];
        this.spinner.hide();
      });
  }

  approved(){
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
        title: AppConstants.TitleModal.APPROVED_CONFIRMATION_TITLE,
        message: `${AppConstants.MessageModal.APPROVED_MESSAGE}`,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR'
        }
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        var payload = {
          id: this.id,
          idUser: localStorage.getItem(AppConstants.Session.USERID)
        }
        this.visitService.approved(payload).subscribe(_ => {
          if(_.error == null){
            this.alertService.showMessage(AppConstants.TitleModal.UPDATE_APPROVED_VISIT, AppConstants.MessageModal.UPDATE_APPROVED, MessageSeverity.success);
            if(this.requested == "true"){
              this.router.navigate(['home/visit/requested']);
            }else if(this.scheduled == "true"){
              this.router.navigate(['home/visit/scheduled']);
            }else if(this.report == "true"){
              this.router.navigate(['home/visit/report']);
            }else{
              this.router.navigate(['home/visit/my-visits']);
            }
          }
        });
      }
    });
  }

  reject(){
    let dialogRef = this.dialog.open(AddVisitRejectModalComponent, {
      data: {
        title: AppConstants.TitleModal.REJECT_CONFIRMATION_TITLE,
        idEnterprise: this.enterpriseSelect,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        cancelled: false,
        color: this.color,
        id:this.id,
        colorFont: this.colorFont},
      width: '500px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if (_.result == true) {
        if(this.requested == "true"){
          this.router.navigate(['home/visit/requested']);
        }else if(this.scheduled == "true"){
          this.router.navigate(['home/visit/scheduled']);
        }else if(this.report == "true"){
          this.router.navigate(['home/visit/report']);
        }else{
          this.router.navigate(['home/visit/my-visits']);
        }
      }
    });
  }

  cancelled(){
    let dialogRef = this.dialog.open(AddVisitRejectModalComponent, {
      data: {
        title: AppConstants.TitleModal.CANCELLED_CONFIRMATION_TITLE,
        idEnterprise: this.enterpriseSelect,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        cancelled: true,
        color: this.color,
        id:this.id,
        colorFont: this.colorFont},
      width: '500px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if (_.result == true) {
        if(this.requested == "true"){
          this.router.navigate(['home/visit/requested']);
        }else if(this.scheduled == "true"){
          this.router.navigate(['home/visit/scheduled']);
        }else if(this.report == "true"){
          this.router.navigate(['home/visit/report']);
        }else{
          this.router.navigate(['home/visit/my-visits']);
        }
      }
    });
  }
}
